































































import { ContractBlockVue } from "fs-pb-vue2/vueModels/contracts-panel/ContractBlockVue";
import { Component } from "vue-property-decorator";
import { ContractModel } from "fs-pb-vue2/models/contracts/contractModel";
import  { CreditRequestStates } from "fs-pb-vue2/data/enums/creditRequestStates";
import sumFilter from "fs-pb-vue2/filters/sum.filter";

@Component({})
export default class ContractBlock extends ContractBlockVue {
  creditPaySum(contract: ContractModel): string {
    if (!contract.Data.DepositSum)
        return sumFilter(contract.Data.MinPaySum);

    const result = contract.Data.MinPaySum - contract.Data.DepositSum;
    return sumFilter(result < 0 ? 0 : result);
  }

  statusColor(contract: ContractModel): string {
    if (contract.Data.CreditRequestData.RequestState == CreditRequestStates.Canceled)
      return 'credit-status-red';
    return 'credit-status';
  }
}
